import { ReactNode } from 'react';
import { Tooltip } from '@mui/material';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import styles from './Info.module.scss';

interface InfoProps {
  title: ReactNode;
  className?: string;
}

const Info = ({ title, className }: InfoProps) => {
  return (
    <Tooltip title={title} placement="top" arrow>
      <HelpOutlineIcon
        className={className ? `${styles.infoIcon} ${className}` : styles.infoIcon}
        fontSize="small"
      />
    </Tooltip>
  );
};

export default Info;
